export default class InteractiveCatalogIndexPage {

    constructor() {
        this.horizontalIndexImage = '';
        this.verticalIndexImage = '';
        this.numPage = 0;
        this.title = '';
        this.description = '';
    }

}
